import { render, staticRenderFns } from "./button-bubble-tr.vue?vue&type=template&id=0f22dcfa&scoped=true&"
var script = {}
import style0 from "./button-bubble-tr.vue?vue&type=style&index=0&id=0f22dcfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f22dcfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f22dcfa')) {
      api.createRecord('0f22dcfa', component.options)
    } else {
      api.reload('0f22dcfa', component.options)
    }
    module.hot.accept("./button-bubble-tr.vue?vue&type=template&id=0f22dcfa&scoped=true&", function () {
      api.rerender('0f22dcfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/button-bubble-tr.vue"
export default component.exports